import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import { getCustomerList } from "@/api/customer/getCustomerList";

export function CustomerList() {
  const query = getCustomerList.useQuery();

  if (query.isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (query.isError) {
    return (
      <Alert severity="error">
        Failed to load customers: {JSON.stringify(query.error)}
      </Alert>
    );
  }

  const customers = query.data ?? [];

  return (
    <>
      <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: "calc(100vh - 160px)" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Display Name</TableCell>
              <TableCell>Currency</TableCell>
              <TableCell>Payment Term</TableCell>
              <TableCell>Price Tier</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="right">Credit Limit</TableCell>
              <TableCell>Parent</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {customers.map((customer) => (
              <TableRow key={customer.id} hover>
                <TableCell sx={{ fontFamily: "monospace" }}>{customer.id}</TableCell>
                <TableCell>{customer.name}</TableCell>
                <TableCell>{customer.displayName}</TableCell>
                <TableCell>{customer.currency}</TableCell>
                <TableCell>{customer.paymentTerm}</TableCell>
                <TableCell>{customer.priceTier}</TableCell>
                <TableCell>{customer.status}</TableCell>
                <TableCell align="right">{customer.creditLimit}</TableCell>
                <TableCell>{customer.parentName ?? "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
